import StorageBox from "Store/StorageBox.js";

import ReactDOM from "react-dom/client";
// Example usage: // Get the root element

class UserChecker {
  LoginChecker() {
    var Username = StorageBox.getProfileUserName();
    console.log(Username);
    console.log("i think this is undefined");
    if (Username != null) {
      return true;
    } else {
      const container = document.createElement("div");
      document.body.appendChild(container);

      const root = ReactDOM.createRoot(container);
      import("components/Javascript_profile/auth/sign-in.jsx").then(
        ({ default: SignIn }) => {
          root.render(<SignIn />);
        }
      );
      return false;
    }
  }

  IsChristian() {
    var religion = StorageBox.getUserReligion();
    console.log(religion);
    console.log("what is the user religion");
    if (religion === "Christianity") {
      return true;
    } else {
      return false;
    }
  }

  IsLoggedIn() {
    var Username = StorageBox.getProfileUserName();
    console.log(Username);
    console.log("i think this is undefined");
    if (Username != null) {
      return true;
    } else {
      return false;
    }
  }
}

export default new UserChecker();

//just thinking, what if the Javascript_Login was rendered more than once
//wouldn't it eventually cause the Javascript_Login Pile up
